import type { ReduxQuote, ReduxRecapInfo } from 'src/types/apiType'
import type { QuoteType } from 'src/types/miscType'
import { calculateGridTotals } from 'src/utils/recapGridUtils/updateRecapGrid'
import { calculateGridTotals1_6 } from 'src/utils/recapGridUtils/updateRecapGridApfp1_6'

function getRecapGridTotals({
	quoteType,
	localRows,
	quoteDetails,
}: {
	quoteType: QuoteType
	localRows: ReduxRecapInfo[]
	quoteDetails: ReduxQuote | null
}) {
	let updatedRows = [] as ReduxRecapInfo[]
	switch (quoteType) {
		case 'frenchApfp':
			updatedRows = getRecapGridTotalsFrenchApfp({
				rows: localRows,
				quoteVersion: quoteDetails?.quoteVersion,
				quoteDetails,
			})
			break
		case 'frenchPostProd':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'aicp':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'photoGrid':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'soundProd':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'cnc5ch':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'quoteAnimationOnly':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'quoteAnimationAndLiveAction':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'blankQuote':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case 'quoteDigital':
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		case '360Template':
			updatedRows = calculateGridTotals1_6({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
			break
		default: {
			const tsCheck: never = quoteType
			updatedRows = calculateGridTotals({
				rows: localRows,
				quoteType,
				quoteDetails,
			})
		}
	}
	return updatedRows
}

function getRecapGridTotalsFrenchApfp({
	rows,
	quoteVersion,
	quoteDetails,
}: {
	rows: ReduxRecapInfo[]
	quoteVersion?: number | null
	quoteDetails: ReduxQuote | null
}) {
	if (quoteVersion && quoteVersion >= 1.6) {
		return calculateGridTotals1_6({
			rows,
			quoteType: 'frenchApfp',
			quoteDetails,
		})
	}
	return calculateGridTotals({ rows, quoteType: 'frenchApfp', quoteDetails })
}

export default getRecapGridTotals
